import React from "react";

const DisplayEventsFromXml = ({
  title,
  description,
  age,
  date,
  ticketUrl,
  mainImage,
  price,
  location,
}) => {
  return (
    <>
      <div
        style={{
          marginBottom: 10,
          marginRight: 15,
          maringleft: 15,
          backgroundColor: "#F6F5F0",
          borderRadius: 10,
        }}>
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
          <div
            style={{
              marginTop: 10,
              position: "relative",
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}>
            <div
              style={{
                borderRadius: 100,
                width: 100,
                height: 100,
                paddingLeft: 2,
                paddingBottom: 1,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#EDEDED",
                marginRight: 8,
                marginLeft: 10,
              }}>
              <img
                style={{
                  borderRadius: 100,
                  width: 100,
                  height: 100,
                  resize: "contain",
                }}
                src={mainImage}
              />
            </div>
            <div style={{ marginRight: 130 }}>
              <label
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: 18,
                  marginBottom: 2,
                  fontFamily: "Inter",
                }}>
                {title}
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    width: "auto",
                    borderRadius: 10,
                    marginBottom: 2,
                    marginRight: 3,
                    backgroundColor: "#4550E2",
                    color: "white",
                    fontSize: 12,
                  }}>
                  {location}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  marginTop: 12,
                  marginBottom: 10,
                  width: "100%",
                }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}>
                  <label
                    style={{
                      color: "black",
                      fontSize: 14,
                    }}>
                    Dato:{" "}
                    {new Date(date).toLocaleDateString("nb-NO", {
                      day: "2-digit", // Ensure the day is two digits
                      month: "2-digit", // Ensure the month is two digits
                      year: "numeric", // Full year
                    })}
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}>
                  <label
                    style={{
                      color: "black",
                      fontSize: 14,
                    }}>
                    Tid:{" "}
                    {new Date(date).toLocaleTimeString("nb-NO", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayEventsFromXml;
